import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import Barcode from 'react-barcode';
import './PopupOffline.css';

const PopupOffline = (props) => {

  const { customer_barcode } = props;


  return <div className="popup_offline"> 
    <div className="popup_content">
      <div className="icon"><img alt={process.env.REACT_APP_NAME} src="/assets/images/logo_white.png" /></div>
      <h2>{i18n.t('noInternetConnection')}</h2>
      <p>{i18n.t('noInternetConnectionText')}</p>
      <div className="barcode">
        <Barcode value={customer_barcode} format="CODE128" />   
      </div>
    </div>
  </div>;
};

export default PopupOffline;